<template>
    <div class="d-flex flex-fill mt-2 mt-md-0">
        <button v-if="agotadas" class="button large-button red-content" disabled>
            {{ $t('partidos.agotadas') }}
        </button>
        <button v-else-if="ultimas_entradas" class="button large-button red-content" disabled>
            {{ $t('eventos.ultimas_entradas') }}
        </button>
        <GoToCheckoutButton
            v-else
            :title="$t('partidos.comprar')"
            :subtitle="teatro.hash === 'BHlBbABzmZ5qkeNOHcGH' ? $t('partidos.futbol_base') : $t('partidos.soy_amigo_abonado', { abonado: teatro.texto_abonado })"
            :route="ruta"
            :event_id="event.id"
            :sesion_id="event.sesion_id"
            tipo_venta="amigosabonados"
        />
    </div>
</template>

<script>
    import GoToCheckoutButton from "@/components/frontend/events/show/GoToCheckoutButton";

    export default {
        props: {
            event: {
                type: Object,
                required: true
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            ruta() { 
                return this.event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.amigosabonados'; 
            },
            agotadas() {
                return !this.event.sesiones_activas && this.event.entradas_agotadas_online;
            },
            ultimas_entradas() {
                return this.event.sesiones_activas && this.event.entradas_agotadas_online;
            }
        },
        components: {
            GoToCheckoutButton
        }
    }
</script>